import { render, staticRenderFns } from "./surveys_page.vue?vue&type=template&id=2ed0a1ff&scoped=true"
import script from "./surveys_page.vue?vue&type=script&lang=js"
export * from "./surveys_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed0a1ff",
  null
  
)

export default component.exports